import { useCallback } from 'react';

import { useTemplateFoundPopup } from 'src/components/TemplateFoundPopup';
import type { TemplateClassifyResult } from 'src/data/template';
import * as ls from 'src/lib/localData';

// TODO: consider moving this logic into prepareTemplateClassifier, and returning a flag
//  indicating whether user approval is needed, along with the aligned tool details.
//  This would allow us to handle user approval as part of the overall template classification flow,
//  and avoid having separate logic for requesting user approval after classification.
export const useRequestClassifiedToolUserApproval = () => {
  const openTemplateFoundPopup = useTemplateFoundPopup();

  return useCallback(
    async (classifiedTemplate: TemplateClassifyResult) => {
      // If user has already chosen to not show the popup, continue with the prompt
      if (ls.templateFoundPopupDoNotShowAgain.read()) {
        return;
      }

      // Request user's approval for the classified tool
      const result = await openTemplateFoundPopup({
        generationTool: classifiedTemplate.generationTool,
        templateName: classifiedTemplate.name,
      });
      // Save user's choice
      if (result?.dontShowAgain) {
        ls.templateFoundPopupDoNotShowAgain.write(true);
      }
      if (!result?.generationTool) {
        return;
      }
      return result;
    },
    [openTemplateFoundPopup]
  );
};
